import React from 'react'
import { Icon } from '~/design_system'

export const ThumbsUp = (props: any) => (
  <Icon {...props} viewBox="0 0 512 512">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="16"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M489.2,286.9c11.3-13.1,17.8-34.7,17.8-55.3c0-13.6-2.9-25.5-8.5-34.4c-7.3-11.6-18.9-18-32.7-18h-67
		c36.5-66.3,45.7-116.3,27.4-148.7C413.3,8,389.9,0,373.8,0c-6.4,0-11.8,4.7-12.7,11.1c-4.6,33.8-30.4,74.1-70.9,110.5
		c-38.7,34.9-86.4,62.9-135.3,79.6c-6.2-13-19.4-22-34.7-22H43.4C22.2,179.2,5,196.4,5,217.6V448c0,21.2,17.2,38.4,38.4,38.4h76.8
		c16.2,0,30.1-10.1,35.7-24.4c50.2,6.3,69.1,16.4,87.4,26.2c22.9,12.2,44.5,23.8,115.3,23.8c18.4,0,35.8-4.8,48.9-13.5
		c12.8-8.5,21-20.5,23.7-34.4c10.2-4.1,19.3-13.7,26.2-27.9c6.7-13.8,11.1-31.5,11.1-45.1c0-2.5-0.2-4.9-0.4-7
		c6.5-4.8,12.3-12.1,17.1-21.8c6.9-13.9,11.1-31.4,11.1-46.7c0-10.9-2-19.9-6-26.9L489.2,286.9L489.2,286.9z M120.2,460.8H43.4
		c-7.1,0-12.8-5.7-12.8-12.8V217.6c0-7.1,5.7-12.8,12.8-12.8h76.8c7.1,0,12.8,5.7,12.8,12.8V448v0C133,455,127.2,460.8,120.2,460.8z
		 M474.4,263c-3.9,7.8-7.8,10.6-9.5,10.6c-7.1,0-12.8,5.7-12.8,12.8c0,7.1,5.7,12.8,12.8,12.8l3,2c1.7,3,2.7,8.2,2.7,14.3
		c0,11.4-3.2,24.9-8.4,35.4c-5.1,10.2-10.2,13.9-12.5,13.9c-7.1,0-12.8,5.7-12.8,12.8c0,4.5,2.4,8.5,5.9,10.8
		c0.8,8.1-3,29.8-12.8,44c-3.7,5.3-7.6,8.4-10.7,8.4c-7.1,0-12.8,5.7-12.8,12.8c0,22.5-24.9,32.8-48,32.8
		c-64.3,0-82.3-9.6-103.2-20.8c-19.5-10.4-41.4-22.1-96.8-29V227c53.8-17.6,106.3-48.1,148.8-86.3c40.8-36.8,67.6-76.5,76.6-113.3
		c7,2.2,14.8,6.9,19.9,15.8c8.5,15.1,14.9,53.7-38.2,142.3c-2.4,3.9-2.4,8.9-0.2,12.9c2.3,4,6.5,6.5,11.1,6.5h89.2
		c5.1,0,8.4,1.8,11,6c3,4.8,4.6,12.2,4.6,20.9C481.4,242.5,478.8,254.3,474.4,263L474.4,263z"
    />
  </Icon>
)
